import { useTheme } from "@material-ui/core"
import React, { useContext, useEffect } from "react"
import DashboardCourses from "~/components/Clients/DashboardCourses"
import DashboardLeftSide from "~/components/Clients/DashboardLeftSide"
import DashboardPaths from "~/components/Clients/DashboardPaths"
import CourseLessonContentContainer from "~/components/Common/CourseLessonContentContainer"
import ClientContext from "~/contexts/Client"
import Page from "~/pages/Page"
import Box from "../../../../../../components/Common/Box"
import useStyles from "./styles"

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

const ClientDashboard = () => {
  const theme = useTheme()
  const classes = useStyles()

  const { client, setClientDetailsValues, setInitialDetailsContext } =
    useContext(ClientContext)

  useEffect(() => {
    if (client?.id) {
      const clientData = {
        name: client?.name,
        domain: client?.domain || "",
        brand_color: client?.brand_color || "#0078F6",
        user_responses: client?.user_responses ? true : false,
        user_stats: client?.user_stats ? true : false,
        time_to_proficiency: client?.time_to_proficiency ? true : false,
        kc_and_final: client?.kc_and_final ? true : false,
        sentiment_evaluation: client?.sentiment_evaluation ? true : false,
        cohort_course_analysis: client?.cohort_course_analysis ? true : false,
        persona_insight: client?.persona_insight ? true : false,
        secret_saml_key: client?.secret_saml_key || "",
        saml_idp_name: client?.saml_idp_name || "",
        stats_users_only: client?.stats_users_only ? true : false,
        use_client_courses_for_stats_endpoint:
          client?.use_client_courses_for_stats_endpoint ? true : false,
        include_questions_answer_client_stats:
          client?.include_questions_answer_client_stats ? true : false,
        stats_endpoint_key: client?.stats_endpoint_key || "",
        dashboard_visible: client?.dashboard_visible ? true : false,
        dashboard_description: client?.dashboard_description || "",
        dashboard_video: client?.dashboard_video || null,
        dashboard_image: client?.dashboard_image || null,
      }
      setClientDetailsValues({ ...clientData })
      setInitialDetailsContext({
        ...clientData,
      })
    }
  }, [client])

  return (
    <Page>
      <CourseLessonContentContainer
        leftComponent={
          <Box className={classes.leftContainer}>
            <DashboardLeftSide />
          </Box>
        }
        rightComponent={
          <Box className={classes.rightContainer}>
            <Box className={classes.courses}>
              <DashboardCourses reorder={reorder} />
            </Box>
            <Box className={classes.courses}>
              <DashboardPaths reorder={reorder} />
            </Box>
          </Box>
        }
      />
    </Page>
  )
}

export default ClientDashboard
